import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './ru/common.json';
import en from './en/common.json';
import es from './es/common.json';
import de from './de/common.json';
import fr from './fr/common.json';

const detectedLang = (() => {
  try {
    const tg = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
    if (tg && ['ru', 'en', 'es', 'de', 'fr'].includes(tg)) return tg;
  } catch { /* ignore */ }
  return 'en';
})();

i18n.use(initReactI18next).init({
  resources: { ru: { common: ru }, en: { common: en }, es: { common: es }, de: { common: de }, fr: { common: fr } },
  lng: detectedLang,
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18n;
